import Vuex from 'vuex';
import Router from 'vue-router';
import { sync } from 'vuex-router-sync';

export default function(options) {
  options.Vue.use(Vuex);
  options.Vue.use(Router);

  let router = null;
  if (options.router) {
    router = new Router(options.router);
  }

  const vuexStore = new Vuex.Store(options.store);

  if (router) {
    sync(vuexStore, router);
  }

  return {
    router,
    store: vuexStore
  }
}
